var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cp-page-head',{attrs:{"page-name":_vm.$t('controlBook.title')}}),_c('cp-top-section'),_c('cp-control-book-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }